import { Flex } from "@similarweb/ui-components/foundations";

import type { TopicsRawData } from "../../../api-client/demandSearchTrendsTopicsAPI";

import { TopicsDiscoverAllTopicsModalMainSectionCategories } from "./TopicsDiscoverAllTopicsModalMainSectionCategories";
import { TopicsDiscoverAllTopicsModalMainSectionTopics } from "./TopicsDiscoverAllTopicsModalMainSectionTopics";

type TopicsDiscoverAllTopicsModalMainSectionProps = {
    data: TopicsRawData;
    activeCategoryName: string;
    setActiveCategoryName: React.Dispatch<React.SetStateAction<string>>;
};

export const TopicsDiscoverAllTopicsModalMainSection = ({
    data,
    activeCategoryName,
    setActiveCategoryName,
}: TopicsDiscoverAllTopicsModalMainSectionProps) => {
    return (
        <Flex overflow="hidden">
            <TopicsDiscoverAllTopicsModalMainSectionCategories
                data={data}
                activeCategoryName={activeCategoryName}
                setActiveCategoryName={setActiveCategoryName}
            />
            <TopicsDiscoverAllTopicsModalMainSectionTopics
                data={data}
                activeCategoryName={activeCategoryName}
            />
        </Flex>
    );
};
